import { aliasGlob } from "./aliases";
import { inventoryGlob } from "./inventory";
import { productGlob } from "./products";
import { geometriesGlob } from "./geometries";
import { tokenGlob } from "./tokens";
import { identifiersGlob } from "./identifiers";
import { classificationsGlob } from "./classifications";
import { effectiveGlob } from "./effective";
import { contactsGlob } from "./contacts";
import { relatedGlob } from "./related";
import { businessGlob } from "../businesses";
import { usersGlob } from "./users";
import { customersGlob } from "../customers";

const rootArea = "/types";

export const typesGlob = (baseArea = "") => ({
	self: `${baseArea}${rootArea}`,
	byType: (typeCode: string) => ({ 	
		self: `${baseArea}${rootArea}/${typeCode}`,
		read: `${baseArea}${rootArea}/${typeCode}/read`,
		write: `${baseArea}${rootArea}/${typeCode}/write`,
		add: `${baseArea}${rootArea}/${typeCode}/add`,
		assign: `${baseArea}${rootArea}/${typeCode}/assign`,
		inventory: inventoryGlob(`${baseArea}${rootArea}/${typeCode}`),
		tokens: tokenGlob(`${baseArea}${rootArea}/${typeCode}`),
		aliases: aliasGlob(`${baseArea}${rootArea}/${typeCode}`),
		products: productGlob(`${baseArea}${rootArea}/${typeCode}`),
		geometries: geometriesGlob(`${baseArea}${rootArea}/${typeCode}`),
		identifiers: identifiersGlob(`${baseArea}${rootArea}/${typeCode}`),
		classifications: classificationsGlob(`${baseArea}${rootArea}/${typeCode}`),
		effective: effectiveGlob(`${baseArea}${rootArea}/${typeCode}`),
		contacts: contactsGlob(`${baseArea}${rootArea}/${typeCode}`),
		related: relatedGlob(`${baseArea}${rootArea}/${typeCode}`),
		business: businessGlob(`${baseArea}${rootArea}/${typeCode}`),
		users: usersGlob(`${baseArea}${rootArea}/${typeCode}`),
		customers: customersGlob(`${baseArea}${rootArea}/${typeCode}`)
	})
});
